<div class="page-container rep-review-container container">
  <app-breadcrumb [crumbConfig]="crumbConfig" />

  @if (amlId === '') {
    <app-rb-grid
      [gridConfig]="gridConfig"
      [getSetup]="getGridSetup"
      [getData]="getGridData"
    />
  } @else {
    <app-aml-monitor-detail [amlId]="amlId" />
  }
</div>
